import { useEffect, useRef } from 'react';
import { Location, useLocation, useNavigationType } from 'react-router';
import { isSamePageAnchorNavigation } from '@lib/isSamePageAnchorNavigation';

export const ScrollToTop = ({ children }: { children: any }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousLocation = useRef<Location | null>(null);

  useEffect(() => {
    const isAnchorClick = navigationType === 'PUSH' && isSamePageAnchorNavigation(previousLocation.current, location);
    previousLocation.current = location;
    if (!isAnchorClick) window.scrollTo(0, 0);
  }, [location, navigationType]);

  return children;
};
